const EDIT_INFO_APP_DEEPLINK =
  'https://modak.go.link/GALILEO_PARENT_HOME/GALILEO_FAMILY?adj_t=192kyn0y_198uyz2p&adj_campaign=edit_flow&adj_deep_link_id=383640';
const EDIT_INFO_APP_DEEPLINK_PROFILE =
  'https://modak.go.link/PROFILE?adj_t=192kyn0y_198uyz2p&adj_campaign=edit_flow&adj_deep_link_id=383640';

export function redirectToEditInfoApp(): void {
  window.location.href = EDIT_INFO_APP_DEEPLINK;
}

export function redirectToEditInfoAppProfile(): void {
  window.location.href = EDIT_INFO_APP_DEEPLINK_PROFILE;
}

export const EDIT_INFO_ROUTES = {
  SUCCESS: '/edit-info/success',
  EXPIRED: '/edit-info/expired',
  REJECT: '/edit-info/reject',
  ERROR: '/edit-info/error',
} as const;

export const RESOLVE_EMAIL_STATUS = {
  APPROVED: 'APPROVED',
  CANCELED: 'CANCELED',
} as const;

type EditInfoImageName =
  | 'moWithPhone'
  | 'moSad'
  | 'moPhoneGlasses'
  | 'moShield';

export function getEditInfoImage(
  name: EditInfoImageName,
  isMoGold: boolean,
): string {
  const folder = isMoGold ? 'gold' : 'standard';
  return `/assets/images/editInfoV2/${folder}/${name}.webp`;
}

export const EDIT_INFO_EVENTS = {
  view_edit_info_not_requested: 'view_edit_info_not_requested',
  view_edit_info_error: 'view_edit_info_error',
  view_edit_info_error_no_data: 'view_edit_info_error_no_data',
  view_edit_info_approved: 'view_edit_info_approved',
  view_edit_info_expired: 'view_edit_info_expired',
  select_edit_info_reset_password: 'select_edit_info_reset_password',
  select_edit_info_back_to_app: 'select_edit_info_back_to_app',
  select_edit_info_back_to_app_from_expired:
    'select_edit_info_back_to_app_from_expired',
  api_edit_info_email_otp_success: 'api_edit_info_email_otp_success',
  select_edit_info_invite_kid: 'select_edit_info_invite_kid',
  share_edit_info_invite_kid_success: 'share_edit_info_invite_kid_success',
  api_edit_info_email_otp_error: 'api_edit_info_email_otp_error',
  select_edit_info_repeat_process: 'select_edit_info_repeat_process',
};
